/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */


export default function getPCPUrl() {
  //return "https://api.paycheckplanner.com/api/";
  return "https://paycheckcore.azurewebsites.net/api/";
  //return "http://localhost:7071/api/";
}

